module.exports = __webpack_public_path__ + "media/images/horsebanner-9278065777f4607763d5c7f62534342e.jpg";